document.addEventListener("DOMContentLoaded", () => {

  const items = document.querySelectorAll(".zpp-item");
  const overlay = document.querySelector(".zpp-overlay");
  const close = document.querySelector(".zpp-close");

  const title = document.querySelector(".zpp-content h2");
  const body = document.querySelector(".zpp-body");

  items.forEach(item => {

    item.addEventListener("click", () => {

      title.textContent = item.dataset.title;

      body.innerHTML = item.dataset.content;

      overlay.classList.add("active");

      document.body.style.overflow = "hidden";

    });

  });

  function closePopup(){

      overlay.classList.remove("active");

      document.body.style.overflow = "";

  }

  close.addEventListener("click", closePopup);

  overlay.addEventListener("click", e => {

      if(e.target === overlay){

          closePopup();

      }

  });

  document.addEventListener("keydown", e => {

      if(e.key === "Escape"){

          closePopup();

      }

  });

});